import type { SearchJourneyOffersDTO } from '@/types/dto/agent';
import { createAction } from '@reduxjs/toolkit';

export const setMapLoaded = createAction<boolean>('mapComponent/setMapLoaded');

export const setMapOpen = createAction<boolean>('mapComponent/setMapOpen');

export const showJourneyMap = createAction<SearchJourneyOffersDTO>(
  'mapComponent/showJourneyMap'
);
